(() => {
  if (!document.body.classList.contains('template-product')) return;
  const content = document.getElementById('MainContent');
  if (!content) return;
  const hasContent = (block) => {
    // Inspect the existing nodes: cloning custom elements invokes Ella's
    // variant constructors and can change the live price/subtotal.
    const meaningful = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return !!node.textContent.trim();
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      if (node.matches('script, style, template, link, [hidden], input[type="hidden"], .hidden, .visually-hidden')) return false;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (node.matches('img, svg, video, iframe, button, input, select, textarea, [role="button"]')) return true;
      return Array.from(node.childNodes).some(meaningful);
    };
    return Array.from(block.childNodes).some(meaningful);
  };
  const refresh = () => {
    content.querySelectorAll('.productView-product > .productView-moreItem').forEach((block) => {
      const empty = !hasContent(block);
      if (block.classList.contains('sw-product-empty') !== empty) block.classList.toggle('sw-product-empty', empty);
    });
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; refresh(); });
  };
  refresh();
  // Async review/pickup/app content restores its block when content arrives.
  const observer = new MutationObserver((records) => {
    const meaningful = records.some((record) => {
      if (record.type !== 'attributes' || record.attributeName !== 'class') return true;
      const normalized = (value) => (value || '').split(/\s+/).filter((name) => name && name !== 'sw-product-empty').sort().join(' ');
      return normalized(record.oldValue) !== normalized(record.target.getAttribute('class'));
    });
    if (meaningful) schedule();
  });
  observer.observe(content, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'], attributeOldValue: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
})();
